var map = {
	"./apx.svg": 74,
	"./bs.svg": 75,
	"./cordova.svg": 76,
	"./css.svg": 77,
	"./fa.svg": 78,
	"./html.svg": 79,
	"./js.svg": 80,
	"./npm.svg": 81,
	"./sass.svg": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;